import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "v-row",
  style: {"gap":"8px","margin":"0 0 1em 0","--button-icon-size":"1.5em"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("播放全部")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("添加到")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-item separator first" }, "我的收藏", -1)
const _hoisted_5 = ["data-index"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-item last" }, "添加到新歌单", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_9 = { class: "cell-text" }
const _hoisted_10 = ["data-mid"]
const _hoisted_11 = ["data-mid"]
const _hoisted_12 = { class: "name" }
const _hoisted_13 = ["data-mid"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" -")
const _hoisted_15 = { class: "name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hl_button = _resolveComponent("hl-button")!
  const _component_popover = _resolveComponent("popover")!
  const _component_icon = _resolveComponent("icon")!
  const _component_table_view = _resolveComponent("table-view")!
  const _component_image_view = _resolveComponent("image-view")!
  const _component_grid_view = _resolveComponent("grid-view")!
  const _component_tab_pane = _resolveComponent("tab-pane")!

  return (_openBlock(), _createBlock(_component_tab_pane, {
    tabs: _ctx.tabs,
    activeTabName: _ctx.activeTabName,
    onTabChange: _ctx.handleTabChanged
  }, {
    song: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_hl_button, { icon: "play-select" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_popover, { "content-class": "dropdown" }, {
          content: _withCtx(() => [
            _hoisted_4,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userSpecials, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["dropdown-item", {separator: index + 1 === _ctx.userSpecials.length}]),
                "data-index": index,
                key: index
              }, _toDisplayString(item.name), 11, _hoisted_5))
            }), 128)),
            _hoisted_6
          ]),
          default: _withCtx(() => [
            _createVNode(_component_hl_button, {
              icon: "plus",
              onClick: _ctx.loadProfileSpecial
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_hl_button, { icon: "my-download" }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_hl_button, { icon: "trash" }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(_component_hl_button, {
          icon: "multiple",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.multiple = !_ctx.multiple))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.multiple ? '退出批量操作' : '批量操作'), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_table_view, {
        style: {"flex":"auto"},
        selection: _ctx.multiple,
        columns: _ctx.columns,
        data: _ctx.songList,
        onRowDblclick: _ctx.playMediaList,
        onInfiniteScroll: _ctx.loadDataList
      }, {
        title: _withCtx(({item}) => [
          _createElementVNode("span", _hoisted_9, _toDisplayString(item.title), 1),
          (item.vip)
            ? (_openBlock(), _createBlock(_component_icon, {
                key: 0,
                class: "vip-icon",
                name: "vip",
                width: "1em",
                height: "1em"
              }))
            : _createCommentVNode("", true),
          (item.vid)
            ? (_openBlock(), _createBlock(_component_icon, {
                key: 1,
                class: "mv-icon",
                name: "mv",
                width: "1em",
                height: "1em"
              }))
            : _createCommentVNode("", true)
        ]),
        singer: _withCtx(({item:{singer:singers = []}}) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singers, (singer, index) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "link cell-text",
              key: index,
              "data-mid": singer.mid
            }, _toDisplayString(singer.name), 9, _hoisted_10))
          }), 128))
        ]),
        album: _withCtx(({item:{album}}) => [
          album
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "link cell-text",
                "data-mid": album.mid
              }, _toDisplayString(album.name), 9, _hoisted_11))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["selection", "columns", "data", "onRowDblclick", "onInfiniteScroll"])
    ]),
    album: _withCtx(() => [
      _createVNode(_component_grid_view, {
        "cell-widths": "repeat(auto-fit, 13em)",
        "cell-height": 234,
        data: _ctx.albumList,
        onInfiniteScroll: _ctx.loadAlbumData,
        onCellClick: _ctx.onAlbumItemClicked
      }, {
        default: _withCtx(({item}) => [
          _createVNode(_component_image_view, {
            modelValue: item.cover,
            "onUpdate:modelValue": ($event: any) => ((item.cover) = $event),
            defaultValue: "icon/album.png"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _createElementVNode("div", _hoisted_12, _toDisplayString(item.name), 1)
        ]),
        _: 1
      }, 8, ["data", "onInfiniteScroll", "onCellClick"])
    ]),
    mv: _withCtx(() => [
      _createVNode(_component_grid_view, {
        class: "arc-rect",
        "cell-widths": "repeat(auto-fit, 16em)",
        data: _ctx.mvList,
        "cell-height": 206,
        onInfiniteScroll: _ctx.loadMvData
      }, {
        default: _withCtx(({item}) => [
          _createVNode(_component_image_view, {
            modelValue: item.cover,
            "onUpdate:modelValue": ($event: any) => ((item.cover) = $event),
            defaultValue: "icon/mv.png"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.singer, (singer, index) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "link",
                key: index,
                "data-mid": singer.mid
              }, _toDisplayString(singer.name), 9, _hoisted_13))
            }), 128)),
            _hoisted_14,
            _createElementVNode("span", null, _toDisplayString(item.title), 1)
          ])
        ]),
        _: 1
      }, 8, ["data", "onInfiniteScroll"])
    ]),
    special: _withCtx(() => [
      _createVNode(_component_grid_view, {
        style: {"margin-top":"1em"},
        "cell-widths": "repeat(auto-fit, 13em)",
        "cell-height": 234,
        data: _ctx.specialList,
        onInfiniteScroll: _ctx.loadSpecialData
      }, {
        default: _withCtx(({item}) => [
          _createVNode(_component_image_view, {
            modelValue: item.cover,
            "onUpdate:modelValue": ($event: any) => ((item.cover) = $event),
            defaultValue: "icon/special.png"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _createElementVNode("div", _hoisted_15, _toDisplayString(item.name), 1)
        ]),
        _: 1
      }, 8, ["data", "onInfiniteScroll"])
    ]),
    _: 1
  }, 8, ["tabs", "activeTabName", "onTabChange"]))
}